import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { extractVariant } from '../slang-utils/extract-variant.js';
import { SlangNode } from './SlangNode.js';
import { YulExpression } from './YulExpression.js';
import { YulBlock } from './YulBlock.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { Doc } from 'prettier';
import type { CollectedMetadata, PrintFunction } from '../types.d.ts';

export class YulIfStatement extends SlangNode {
  readonly kind = NonterminalKind.YulIfStatement;

  condition: YulExpression['variant'];

  body: YulBlock;

  constructor(ast: ast.YulIfStatement, collected: CollectedMetadata) {
    super(ast, collected);

    this.condition = extractVariant(
      new YulExpression(ast.condition, collected)
    );
    this.body = new YulBlock(ast.body, collected);

    this.updateMetadata(this.condition, this.body);
  }

  print(print: PrintFunction): Doc {
    return ['if ', print('condition'), ' ', print('body')];
  }
}
